import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1156585f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1156585f')) {
      api.createRecord('1156585f', component.options)
    } else {
      api.reload('1156585f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1156585f", function () {
      api.rerender('1156585f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabRadio/index.vue"
export default component.exports